import { useHydrating } from "eddev/routing"
import { useEffect, useState } from "react"
import { useCallbackRef } from "./useCallbackRef"

const breakpoints = { sm: 600, md: 900, lg: 1200, xl: 1600, xxl: 2000 }

const getValue = (): BreakpointName => {
  if (typeof window === "undefined") return "sm"
  const windowSize = window.innerWidth
  let result = "BASE"
  for (let [key, width] of Object.entries(breakpoints)) {
    if (windowSize > width) {
      result = key as BreakpointName
    }
  }
  return result as BreakpointName
}

export type BreakpointName = "BASE" | keyof typeof breakpoints

export function useBreakpoint(): BreakpointName {
  const [value, setValue] = useState<BreakpointName>("BASE")

  useBreakpointChange(setValue)

  return value
}

export function useBreakpointChange(handler: (bp: BreakpointName) => void) {
  const onChange = useCallbackRef(handler)

  useEffect(() => {
    let last = "BASE"
    const onResize = () => {
      const next = getValue()
      if (next !== last) {
        last = next
        onChange(next)
      }
    }
    onResize()
    window.addEventListener("resize", onResize)
    return () => {
      window.removeEventListener("resize", onResize)
    }
  }, [])
}
